import { render, staticRenderFns } from "./FavoritesButtons.vue?vue&type=template&id=26897954&scoped=true&"
import script from "./FavoritesButtons.vue?vue&type=script&lang=js&"
export * from "./FavoritesButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26897954",
  null
  
)

export default component.exports